import { Box } from '@mui/material';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Confirmation from './Components/Confirmation/Confirmation';
import GenericError from './Components/Error/GenericError';
import NotFoundError from './Components/Error/NotFoundError';
import Landing from './Components/Landing/Landing';
import RegionSelect from './Components/RegionSelect/RegionSelect';

const App: any = () => {
    return (
        <Box id="app">
            <Routes>
                <Route path="error" element={<GenericError />} />
                <Route path="error/:paymentSolutionName/:culture" element={<GenericError />} />
                <Route path="confirmation/:paymentSolutionName/:culture" element={<Confirmation />} />
                <Route path="notfound" element={<NotFoundError />} />
                <Route path="/:paymentSolutionName" element={<RegionSelect />} />
                <Route path="/:paymentSolutionName/:culture" element={<Landing />} />
                <Route path="/:paymentSolutionName/:culture/:base64String" element={<Landing />} />
                <Route path="/:paymentSolutionName/_/:base64String" element={<RegionSelect />} />
                <Route path="*" element={<NotFoundError />} />
            </Routes>
        </Box>
    )
}

export default App;